import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation updateNextScreeningDate(
    $data: updateNextReadingDateInput!
    $id: String!
  ) {
    updateNextScreeningDate(data: $data, id: $id) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const updateNextScreeningDateRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {data: TYPES.UpdateNextReadingDateInput;id: String;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'subject/update_next_screening_date',
  async (
  params: {data: TYPES.UpdateNextReadingDateInput;id: String;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.updateNextScreeningDate;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const updateNextScreeningDateSlice = createSlice({
  name: 'update_next_screening_date',
  initialState: initialState,
  reducers: {
    updateNextScreeningDateClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(updateNextScreeningDateRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(
      updateNextScreeningDateRequest.fulfilled,
      (state, action) => {
        state.result = action.payload;
        state.loading = false;
      }
    ).
    addCase(updateNextScreeningDateRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { updateNextScreeningDateClear } =
updateNextScreeningDateSlice.actions;

export const updateNextScreeningDate = createSelector(
  (state: RootState) => state.subject.updateNextScreeningDate.result,
  (state: RootState) => state.subject.updateNextScreeningDate.error,
  (state: RootState) => state.subject.updateNextScreeningDate.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default updateNextScreeningDateSlice.reducer;